import { App, Checkbox, DatePicker, Form, Input, InputNumber, Modal, Space } from "antd";
import { CloseSquareFilled, SaveFilled } from '@ant-design/icons';
import { useEffect, useState } from "react";
import execute from "hooks/execute";
import { protectedResources } from "config/msalConfig";
import { get } from "lodash";
import styled from "styled-components";

export const DataEditor = ({isOpen, dataItem, onDataEditorFinished, onDataEditorCancelled }) => {
    const [form] = Form.useForm();
    const { message } = App.useApp();

    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(false);


    const fetchModules = async () => {
            setLoading(true)
            try {
      
              execute("GET", `${protectedResources.api.baseEndPoint}/modules`).then((response) => {
                if (response && response.success) {
                  console.log('response', response);
                  setModules(response.data); // Adjust the response according to your API
                }
              });
      
      
            } catch (error) {
              console.error('Error fetching modules:', error);
            }

            setLoading(false)
    };
    

    const handleDataEditFinished = async (values) => {
        console.log("handleDataEditFinished");
        var newData = {...dataItem, ...values};
        console.log(newData);

        // Build module assignment map dynamically so newly added modules are included.
        const moduleKeys = modules.map((module) => module.ShortName);
        const modulesAssigned = moduleKeys.reduce((acc, shortName) => {
            acc[shortName] = Boolean(newData[shortName]);
            return acc;
        }, {});

        newData.modulesAssigned = modulesAssigned;
        console.log(modulesAssigned);
        console.log(newData);

        // return

        if(dataItem){
            console.log("edit")
            // return;
            // call api to update data
            const response = await execute('PUT',`${protectedResources.api.baseEndPoint}/organizations`, newData );
            if(response.success){
                message.success("Organization updated successfully");
                newData = {...newData, ...response.data};
            }else{
                message.error(response.message);
                return;
            }
        }
        else{
            console.log("add")
            // call  api to add data
            const response = await execute('POST',`${protectedResources.api.baseEndPoint}/organizations`, newData);
            if(response.success){   
                message.success("Organization added successfully");
                newData = {...newData, ...response.data};
            }else{
                message.error(response.message);
                return;
            }
        }
        onDataEditorFinished(newData);
    }

    const handleDataEditCancelled = () => {
        console.log("handleDataEditCancelled");
        onDataEditorCancelled();
    }
    
    useEffect(() => {
        // Convert Modules string to an array
        console.log(dataItem)
        if(isOpen){
            if(dataItem){

                form.setFieldsValue({
                    organizationName: dataItem?.Org_Name || '',
                    address: dataItem?.Org_Address || '',
                    adminEmail: dataItem?.Org_Email || '',
                    // adminEmail: dataItem.Org_Email || '',
                });
            }
            
        }
    }, [isOpen, dataItem, form]);

    useEffect(() => {
        if (!isOpen) return;

        const modulesValue = dataItem?.Modules;
        const selectedModules = Array.isArray(modulesValue)
            ? modulesValue
            : (typeof modulesValue === "string" ? modulesValue.split(",").map(module => module.trim()) : []);

        const moduleValues = selectedModules.reduce((acc, module) => {
            acc[module] = true;
            return acc;
        }, {});

        form.setFieldsValue({
            ...moduleValues
        });
    }, [isOpen, dataItem, form])

    useEffect(()=>{
        fetchModules()
    },[])



    return (
        <Modal
            open={isOpen}
            className="h-3"
            title={dataItem ? "Edit Organization" : "Add New Organization"}
            okText={<Space><SaveFilled />Save</Space> }
            cancelText={<Space><CloseSquareFilled />Cancel</Space> }
            okButtonProps={{ autoFocus: true, htmlType: 'submit' }} //form: 'dataEditorForm', key: 'submit'
            onCancel={handleDataEditCancelled}
            destroyOnClose
            modalRender={(dom) => (
                <Form
                style={{height: "80vh", overflowY: "auto"}}
                  layout="horizontal"
                  form={form}
                  name="dataEditorForm"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  initialValues={{
                    modifier: 'public',
                  }}
                  clearOnDestroy
                  onFinish={handleDataEditFinished}
                >
                  {dom}
                </Form>
            )}>            
            <Form.Item
                name="organizationName"
                label="Organization Name"
                rules={[{ required: true, message: 'Organization Name is required' }]}>
                <Input />
            </Form.Item>


            <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: 'Address is required' }]}>
                <Input />
            </Form.Item>
            <Form.Item
                name="adminEmail"
                label="Admin User Email"
                rules={[
                    { required: true, message: 'Admin User Email is required' },
                ]}>
                <Input readOnly={dataItem}/>
            </Form.Item>

            <Form.Item
                label="Modules To Assign"
                name="modulesAssigned"
            >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0px' }}>
            
                {modules.map((module) => (
                     <Form.Item
                     key={module.ShortName}
                     style={{marginBottom: 8, height: "fit-content"}}
                     name={module.ShortName}
                     valuePropName="checked"
                 >
                    <Checkbox>{module.ModuleName}</Checkbox>
                  </Form.Item>
                ))}
                </div>
            </Form.Item>
            
        </Modal>
    );
};


const FormLabel = styled.label`
display: block;  // Ensures the label is a block element
margin-bottom: 8px;  // Increased space between the label text and the input field
color: #333;  // Optional: text color for the label
`;
